import { postPartySearch, postPartySearchPublic, } from '@zurich/api/search';
import { useIndexSearch } from './useIndexSearch';
export function usePartySearch(isPublicSearch, options) {
    return useIndexSearch({
        request: isPublicSearch ? postPartySearchPublic : postPartySearch,
        suggestions: options?.suggestions,
    });
}
